import { Box, Container, Grid, Tab, Tabs, Typography } from "@mui/material";
import CustomerInvoiceList from "../components/customerInvoice/CustomerInvoiceList";
import { useSelector } from "react-redux";
import NoPermissionPage from "../../components/common/NoPermissionPage";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getFinancialAction } from "../../store/reducers/quickBookSlice";
import PayConfirmationList from "../components/payConfirmation/PayConfirmationList";

const ClientAccountSetting = () => {
  const dispatch = useDispatch();
  const [value, setValue] = useState("0");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const { invoices } = useSelector((state: any) => state.invoice);

  const { invoiceModulePermission, user } = useSelector(
    (state: any) => state?.user
  );

  useEffect(() => {
    dispatch(getFinancialAction());
  }, []);

  return (
    <>
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        sx={{
          background: "#f4f4f4",
          paddingTop: "16px",
        }}
      >
        <Grid item xs={12} md={12}>
          <Tabs
            // centered
            value={value}
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="secondary tabs example"
            variant="standard"
            sx={{
              background: "#fff",
              fontSize: "14px",
              fontWeight: 600,
              marginBottom: "16px",
            }}
          >
            <Tab value="0" label="Customer Invoice" />
            <Tab value="1" label="Pay Confirmation" />
          </Tabs>
         {value === '0' && <Container
            maxWidth="xl"
            sx={{
              bgcolor: "#fff",
              padding: "16px !important",
              borderRadius: "10px",
              width: "100%",
              minWidth: "100%",
            }}
          >
            <Typography
              sx={{ fontWeight: 700, textAlign: "center", mb: 2 }}
              variant="h5"
            >
              Accounts Page
            </Typography>
            <Box
              sx={{
                bgcolor: "#fff",
                height: {
                  xs: "auto",
                  md: invoices.length > 0 ? "100%" : "100vh",
                },
                border: "1px solid #d1cfcf",
                borderRadius: "5px",
                padding: "4px 12px",
                paddingBottom: "50px",
              }}
            >
              {user?.user?.roles?.includes("Owner") ||
              user?.user?.roles?.includes("TENANT") ||
              invoiceModulePermission?.read ? (
                <CustomerInvoiceList />
              ) : (
                <NoPermissionPage />
              )}
            </Box>
          </Container>}
          {/* pay confirmation */}
          {value === '1' && <Container
            maxWidth="xl"
            sx={{
              bgcolor: "#fff",
              padding: "16px !important",
              borderRadius: "10px",
               width: "100%",
              minWidth: "100%",
            }}
          >
            <Typography
              sx={{ fontWeight: 700, textAlign: "center", mb: 2 }}
              variant="h5"
            >
              Pay Confirmation
            </Typography>
            <Box
              sx={{
                bgcolor: "#fff",
                height: {
                  xs: "auto",
                  md: invoices.length > 0 ? "100%" : "100vh",
                },
                border: "1px solid #d1cfcf",
                borderRadius: "5px",
                padding: "4px 12px",
                paddingBottom: "50px",
              }}
            >
              {user?.user?.roles?.includes("Owner") ||
              user?.user?.roles?.includes("TENANT") ||
              invoiceModulePermission?.read ? (
                <PayConfirmationList />
              ) : (
                <NoPermissionPage />
              )}
            </Box>
          </Container>}
        </Grid>
      </Grid>
    </>
  );
};

export default ClientAccountSetting;
